export class ListZeroEtlPoliciesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "zeroEtlPolicies",
            "baseName": "zeroEtlPolicies",
            "type": "Array<ZeroEtlPolicy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListZeroEtlPoliciesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
